<template>
  <td>
    <div class="d-flex px-2 py-1">
      <a href="#" @click.prevent="this.getPdf(item)"
        class="text-secondary font-weight-bold cursor-pointer me-2"
        v-if="!this.commessa.closed">
        <i class="fas fa-file-pdf"></i>
      </a>
      <span class="text-secondary text-xs font-weight-bold align-middle mt-1">
        <i class="fa fa-solid fa-circle text-danger" v-if="item.final_judgement === 'non conforme'"></i>
        <i class="fa fa-solid fa-circle text-success" v-if="item.final_judgement === 'conforme'"></i>
        <i class="fa fa-solid fa-circle text-yellow" v-if="item.final_judgement === 'in sospeso'"></i>
      </span>
    </div>
  </td>
  <td>
    <div class="d-flex px-2 py-1">
      <span class="text-secondary text-xs font-weight-bold">
        <a @click.prevent="this.editTube"
          class="text-secondary font-weight-bold cursor-pointer"
          data-toggle="tooltip"
          data-original-title="Modifica">
          <i class="fa fa-pen" v-if="!this.commessa.closed || this.user.roles !== 'operatore'"></i>
          <i class="fa fa-eye" v-else></i>
        </a>
        {{ item.tube_number }}
      </span>
    </div>
  </td>
  <td>
    <div class="d-flex px-2 py-1">
      <span class="text-secondary text-xs font-weight-bold">
        {{ item.factory_number }}
      </span>
    </div>
  </td>
  <td class="align-middle text-center text-sm">
    <span class="text-secondary text-xs font-weight-bold">
      {{ item.serial_number }}
      <a href="#" 
         @click.prevent="openHistoryModal"
         class="text-primary ms-2 cursor-pointer"
         data-toggle="tooltip"
         data-original-title="Visualizza storico matricole"
         v-if="hasHistory">
        <i class="fas fa-history"></i>
      </a>
    </span>
  </td>
  <td class="align-middle">
    <a id="excel{{item._id}}"
      href="#"
      @click.prevent="this.exportExcel(item)"
      class="text-secondary font-weight-bold cursor-pointer me-2">
      <i class="fas fa-file-excel"></i>
    </a>
    <tube-delete-btn :tube-prop="item" :commessa-id="this.commessa._id"></tube-delete-btn>
  </td>

  <div class="modal fade" :id="'historyModal' + item._id" tabindex="-1" role="dialog" aria-labelledby="historyModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="historyModalLabel">
            Storico Matricole - Tubo {{ item.tube_number }}
          </h5>
          <button type="button" 
                  class="btn-close" 
                  data-bs-dismiss="modal" 
                  aria-label="Close">
          </button>
        </div>
        <div class="modal-body">
          <div v-if="loadingHistory" class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Caricamento...</span>
            </div>
          </div>
          <div v-else-if="historyError" class="alert alert-danger">
            {{ historyError }}
          </div>
          <div v-else-if="!serialHistory || serialHistory.length === 0" class="alert alert-info">
            Nessuno storico disponibile per questo tubo.
          </div>
          <div v-else class="table-responsive">
            <table class="table table-sm table-striped">
              <thead>
                <tr class="text-center">
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder">
                    Data
                  </th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder">
                    Numero Commessa
                  </th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder">
                    Matricola Tubo
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(record, index) in serialHistory" :key="index" class="text-center">
                  <td class="text-xs font-weight-normal">
                    {{ formatDate(record.date) }}
                  </td>
                  <td class="text-xs font-weight-normal">
                    {{ record.commessa_number_old }}
                  </td>
                  <td class="text-xs font-weight-bold">
                    {{ record.serial_number_old }}
                  </td>
                  <td>
                      <i class="fa fa-solid fa-circle text-danger" v-if="record.final_judgement_old === 'non conforme'"></i>
                      <i class="fa fa-solid fa-circle text-success" v-if="record.final_judgement_old === 'conforme'"></i>
                      <i class="fa fa-solid fa-circle text-yellow" v-if="record.final_judgement_old === 'in sospeso'"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">
            Chiudi
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useTubeStore from "@/store/tube.store";
import axios from "axios";
import useCommessaStore from "@/store/commessa.store";
import { getItem } from "@/utility/localStorageControl";
import TubeDeleteBtn from "@/views/tube/tubeDeleteBtn.vue";
import { Modal } from "bootstrap";

export default {
  name: "table-tube-row",
  components: { TubeDeleteBtn },
  props: {
    updateTableTubeRow: {
      type: Function,
    },
    item: {
      type: Object,
      required: false,
    },
  },
  watch: {
    item(newValue) {
      this.tube = newValue;
    },
  },
  data() {
    return {
      tube: {},
      user: {},
      commessa: {},
      serialHistory: [],
      loadingHistory: false,
      historyError: null,
      hasHistory: false,
    };
  },
  async mounted() {
    this.user = getItem("user");
    this.commessa = await useCommessaStore().getCommessa();
    // Verifica se il tubo ha uno storico
    await this.checkHistory();
  },
  methods: {
    async editTube() {
      this.tube = this.item;
      const response = await axios.get(
          this.$endpoint + "/commessa/tube/pictrureobj/" + this.tube._id,
          {
            headers: {
              authorization: process.env.VUE_APP_APY_KEY,
            },
          }
      );

      this.tube.picture = response.data.picture
      await useTubeStore().setTube(this.tube);
      this.updateTableTubeRow(this.tube, 3);
    },
    async getPdf(tube) {
      if (tube) {
        const response = await axios.get(
          this.$endpoint + "/commessa/pdf/tube/" + tube._id,
          {
            responseType: "blob",
            headers: {
              authorization: process.env.VUE_APP_APY_KEY,
            },
          }
        );
        // Converti l'Array Buffer in un Blob
        const pdfBlob = new Blob([response.data], { type: "application/pdf" });
        // Crea un URL oggetto dal Blob
        const pdfURL = URL.createObjectURL(pdfBlob);
        // Apri una nuova scheda del browser con l'URL del PDF
        window.open(pdfURL, "_blank");
      }
    },
    async exportExcel(tube) {
      if (tube) {
        const response = await axios.get(
          this.$endpoint + "/commessa/excel/tube/" + tube._id,
          {
            responseType: "blob",
            headers: {
              authorization: process.env.VUE_APP_APY_KEY,
            },
          }
        );

        // Converti l'Array Buffer in un Blob
        const excelBlob = new Blob([response.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        // Crea un URL oggetto dal Blob
        const excelURL = URL.createObjectURL(excelBlob);
        // Crea un elemento <a> e impostalo per il download
        const link = document.createElement("a");
        link.href = excelURL;
        const fileName = `commessa-${this.commessa.number}.xlsx`;
        link.setAttribute("download", fileName);

        // Aggiungi l'elemento <a> al DOM
        document.body.appendChild(link);

        // Clicca sul link per avviare il download
        link.click();

        // Rimuovi l'elemento <a> dal DOM
        document.body.removeChild(link);
      }
    },
    async openHistoryModal() {
      // Reset dello stato
      this.serialHistory = [];
      this.loadingHistory = true;
      this.historyError = null;

      // Apri la modale
      const modalEl = document.getElementById('historyModal' + this.item._id);
      const modal = new Modal(modalEl);
      modal.show();

      try {
        const response = await axios.get(
          this.$endpoint + "/commessa/tube/serial-history/" + this.item._id,
          {
            headers: {
              authorization: process.env.VUE_APP_APY_KEY,
            },
          }
        );

        // Verifica che la risposta contenga lo storico
        if (response.data && response.data.history && Array.isArray(response.data.history)) {
          // Ordina per data decrescente (più recenti prima)
          this.serialHistory = response.data.history.sort((a, b) => {
            return new Date(b.date) - new Date(a.date);
          });
        } else {
          this.serialHistory = [];
        }

      } catch (error) {
        console.error("Errore nel recupero dello storico:", error);
        this.historyError = "Impossibile recuperare lo storico delle matricole.";
        this.serialHistory = [];
      } finally {
        this.loadingHistory = false;
      }
    },
    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleDateString("it-IT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      });
    },
    async checkHistory() {
      // Verifica silenziosamente se esiste uno storico per questo tubo
      try {
        const response = await axios.get(
          this.$endpoint + "/commessa/tube/serial-history/" + this.item._id,
          {
            headers: {
              authorization: process.env.VUE_APP_APY_KEY,
            },
          }
        );

        // Controlla se ci sono dati storici
        if (response.data && response.data.status === 'OK' && response.data.history && Array.isArray(response.data.history) && 
          response.data.history.length > 0) {
          this.hasHistory = true;
        } else {
          this.hasHistory = false;
        }
      } catch (error) {
        // In caso di errore, nascondi l'icona
        this.hasHistory = false;
      }
    },
  },
};
</script>
